export function appendExternalUrl(url) {
    return `${process.env.VUE_APP_STRAPI_URL}${url}`;
}